module.exports = __webpack_public_path__ + "static/img/hat.b2d41b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/hat.png
// module id = 6l3L
// module chunks = 0